module.exports = __webpack_public_path__ + "media/images/lesson_5/animais-2d06d6269f797e96264e4d8dcef27144.jpg";